import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { isModifiedClick, openInNewTab, resolveAppHref } from '@/utils/navigation';
export const useNavigateFromClick = () => {
	const navigate = useNavigate();
	const location = useLocation();
	return useCallback(
		(event, to, options) => {
			if (!to) return;
			if (isModifiedClick(event)) {
				event?.preventDefault?.();
				openInNewTab(resolveAppHref(to, location.pathname));
				return;
			}
			navigate(to, options);
		},
		[location.pathname, navigate],
	);
};
